module.exports = __webpack_public_path__ + "DoodleAndDream.webp?ec2fa1688567c4270f647b584bf35100";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/DoodleAndDream.webp
// module id = 74
// module chunks = 0